module.exports = __webpack_public_path__ + "img/247.6800003a.jpg";